import { render, staticRenderFns } from "./RewardFlow.vue?vue&type=template&id=31575404&scoped=true"
import script from "./RewardFlow.vue?vue&type=script&lang=js"
export * from "./RewardFlow.vue?vue&type=script&lang=js"
import style0 from "./RewardFlow.vue?vue&type=style&index=0&id=31575404&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31575404",
  null
  
)

export default component.exports